import { render, staticRenderFns } from "./product-category.vue?vue&type=template&id=c8ae9222"
import script from "./product-category.vue?vue&type=script&lang=js"
export * from "./product-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports